import DateRangePersistentService from 'nightwatch-web/services/persistence/date-range';

export default class KeywordListService extends DateRangePersistentService {
  RANGE_KEY = 'nw:nw-keyword-list:date-range';
}
